// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Typography-module__normal--pAHPe {
}

.Typography-module__semibold--TFG3F {
    font-weight: 600;
}

.Typography-module__bold--qrUj0 {
    font-weight: 700;
}

.Typography-module__main--jk2Yg {
    overflow: hidden;
    text-overflow: ellipsis;
}
`, "",{"version":3,"sources":["webpack://./src/dom/components/Typography/Typography.module.css"],"names":[],"mappings":"AAAA;AACA;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;AAC3B","sourcesContent":[".normal {\n}\n\n.semibold {\n    font-weight: 600;\n}\n\n.bold {\n    font-weight: 700;\n}\n\n.main {\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"normal": `Typography-module__normal--pAHPe`,
	"semibold": `Typography-module__semibold--TFG3F`,
	"bold": `Typography-module__bold--qrUj0`,
	"main": `Typography-module__main--jk2Yg`
};
export default ___CSS_LOADER_EXPORT___;
